// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .purchaseexecutive-wrapper {
  padding: 2rem;
  background: #eef1f5;
  min-height: 100vh;
}

.purchaseexecutive-page-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1e293b;
  text-align: center;
  margin-bottom: 2rem;
}

.purchaseexecutive-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
}

.purchaseexecutive-card {
  background-color: #ffffff;
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.purchaseexecutive-card:hover {
  transform: translateY(-5px);
}

.purchaseexecutive-card-header {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.purchaseexecutive-card-title {
  font-size: 1.3rem;
  color: #0f172a;
  font-weight: 600;
}

.purchaseexecutive-card-subtitle {
  font-size: 0.9rem;
  color: #64748b;
}

.purchaseexecutive-card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.purchaseexecutive-route-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 500;
  color: #334155;
  font-size: 0.95rem;
}

.purchaseexecutive-route-icon {
  font-size: 1.3rem;
  color: #2563eb;
}

.purchaseexecutive-details-grid {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.purchaseexecutive-detail-item {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  border-bottom: 1px dashed #e2e8f0;
  padding-bottom: 0.4rem;
}

.purchaseexecutive-label {
  color: #475569;
  font-weight: 500;
}

.purchaseexecutive-value {
  color: #1e293b;
  font-weight: 600;
}

.purchaseexecutive-loading-container {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #334155;
  font-size: 1rem;
}

.purchaseexecutive-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #cbd5e1;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .purchaseexecutive-page-title {
    font-size: 1.6rem;
  }

  .purchaseexecutive-details-grid {
    gap: 0.6rem;
  }

  .purchaseexecutive-detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
  }
}

.purchaseexecutive-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.purchaseexecutive-header-left {
  display: flex;
  flex-direction: column;
}

.purchaseexecutive-card-title {
  font-size: 1.2rem;
  color: #0f172a;
  font-weight: 600;
}

.purchaseexecutive-card-subtitle {
  font-size: 0.85rem;
  color: #64748b;
  margin-top: 4px;
}

.purchaseexecutive-add-btn {
  padding: 0.4rem 1rem;
  background-color: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
}

.purchaseexecutive-add-btn:hover {
  background-color: #1d4ed8;
} */

/* *** */

.purchaseexecutive-wrapper {
  padding: 20px;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.purchaseexecutive-page-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.purchaseexecutive-container {
  max-width: 1200px;
  margin: 0 auto;
}

.purchaseexecutive-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 20px;
  transition: transform 0.2s ease-in-out;
}

.purchaseexecutive-card:hover {
  transform: translateY(-5px);
}

.purchaseexecutive-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.purchaseexecutive-header-left {
  display: flex;
  flex-direction: column;
}

.purchaseexecutive-card-title {
  font-size: 1.5rem;
  color: #2c3e50;
  margin: 0;
}

.purchaseexecutive-card-subtitle {
  font-size: 0.9rem;
  color: #7f8c8d;
}

.purchaseexecutive-add-btn {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s;
  margin-left: 5px;
}

.purchaseexecutive-add-btn:hover {
  background-color: #2980b9;
}

.purchaseexecutive-route-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.purchaseexecutive-route-details {
  font-size: 1.1rem;
}

.purchaseexecutive-route-from,
.purchaseexecutive-route-to {
  font-weight: 600;
  color: #2c3e50;
}

.purchaseexecutive-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.purchaseexecutive-detail-item {
  display: flex;
  flex-direction: column;
}

.purchaseexecutive-label {
  font-size: 0.9rem;
  color: #7f8c8d;
  font-weight: 500;
}

.purchaseexecutive-value {
  font-size: 1rem;
  color: #2c3e50;
  word-break: break-word;
}

.purchaseexecutive-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  color: #7f8c8d;
}

.purchaseexecutive-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1024px) {
  .purchaseexecutive-page-title {
    font-size: 1.8rem;
  }

  .purchaseexecutive-card {
    padding: 15px;
  }

  .purchaseexecutive-card-title {
    font-size: 1.3rem;
  }

  .purchaseexecutive-details-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) {
  .purchaseexecutive-wrapper {
    padding: 15px;
  }

  .purchaseexecutive-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .purchaseexecutive-add-btn {
    width: 100%;
  }

  .purchaseexecutive-route-details {
    font-size: 1rem;
  }

  .purchaseexecutive-details-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .purchaseexecutive-page-title {
    font-size: 1.5rem;
  }

  .purchaseexecutive-card {
    padding: 10px;
  }

  .purchaseexecutive-card-title {
    font-size: 1.1rem;
  }

  .purchaseexecutive-card-subtitle {
    font-size: 0.8rem;
  }

  .purchaseexecutive-add-btn {
    padding: 6px 12px;
    font-size: 0.8rem;
  }

  .purchaseexecutive-value {
    font-size: 0.9rem;
  }
}

/* show all master */

/* .masterpage-view-btn {
  padding: 10px 20px;
  background-color: #fab005;
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  font-size: 15px;
  font-weight: 500;
}

.masterpage-view-btn:hover {
  background-color: #f08c00;
  transform: translateY(-2px);
}

.masterpage-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.masterpage-popup {
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
}

.masterpage-popup-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
}

.masterpage-popup-header h3 {
  margin: 0;
  color: #212529;
  font-size: 20px;
  font-weight: 600;
}

.masterpage-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  transition: color 0.3s ease;
}

.masterpage-close-btn:hover {
  color: #343a40;
}

.masterpage-popup-content {
  padding: 20px;
}

.masterpage-popup-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  border-left: 4px solid #fab005;
}

.masterpage-popup-card p {
  margin: 6px 0;
  color: #495057;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.masterpage-popup-card p strong {
  color: #343a40;
  font-weight: 500;
  min-width: 120px;
}

.masterpage-popup-card p span {
  color: #6c757d;
  flex: 1;
  word-break: break-word;
}

@media (max-width: 768px) {
  .masterpage-wrapper {
    padding: 15px;
  }

  .masterpage-header {
    padding: 12px 15px;
  }

  .masterpage-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .masterpage-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }

  .masterpage-popup {
    width: 95%;
    max-height: 85vh;
  }
}

@media (max-width: 480px) {
  .masterpage-header {
    padding: 10px;
  }

  .masterpage-search-input {
    max-width: 100%;
  }

  .masterpage-grid {
    grid-template-columns: 1fr;
  }

  .masterpage-card {
    padding: 12px 15px;
  }

  .masterpage-card p {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .masterpage-card p strong {
    min-width: auto;
  }

  .masterpage-popup-card p {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .masterpage-popup-card p strong {
    min-width: auto;
  }
} */

.masterpage-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 15, 15, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}

.masterpage-popup {
  background-color: #ffffff;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  position: relative;
  padding: 24px 24px 16px;
  animation: popupSlideIn 0.3s ease-out;
}

.masterpage-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.masterpage-popup-header h3 {
  font-size: 20px;
  margin: 0;
  color: #222;
}

.masterpage-close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #888;
  cursor: pointer;
  transition: color 0.2s ease;
}

.masterpage-close-btn:hover {
  color: #000;
}

.masterpage-popup-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.masterpage-popup-card {
  background: #f9f9f9;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.masterpage-popup-card p {
  margin: 6px 0;
  font-size: 14px;
  color: #333;
}

.masterpage-popup-card strong {
  font-weight: 600;
  color: #111;
}

@keyframes popupSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .masterpage-popup {
    max-width: 95%;
    padding: 20px 16px;
  }

  .masterpage-popup-card p {
    font-size: 13px;
  }

  .masterpage-popup-header h3 {
    font-size: 18px;
  }

  .masterpage-close-btn {
    font-size: 22px;
  }
}

.masterpage-popup-card_button {
  background-color: #2563eb; /* blue-600 */
  color: white;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, transform 0.1s ease;
  margin-left: 65%;
}

.masterpage-popup-card_button:hover {
  background-color: #1d4ed8; /* blue-700 */
  transform: translateY(-2px);
}

.masterpage-popup-card_button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* matsrer response form */

/* Overlay */
.responseformmaster-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 9999;
}

.responseformmaster-popup {
  background: #fff;
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  height: 600px;
  overflow: auto;
}

.responseformmaster-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: #2563eb;
  color: white;
}

.responseformmaster-close-btn {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
}

.responseformmaster-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.responseformmaster-content h4 {
  margin-top: 1rem;
  color: #333;
}

.responseformmaster-input {
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 10px;
  width: 100%;
  box-sizing: border-box;
}

.responseformmaster-submit-btn {
  background-color: #2563eb;
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.responseformmaster-submit-btn:hover {
  background-color: #1e40af;
}

@media (max-width: 768px) {
  .view_add_vutton {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
  .responseformmaster-popup {
    max-width: 100%;
  }

  .responseformmaster-content {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .view_add_vutton {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
  .responseformmaster-header h3 {
    font-size: 1rem;
  }

  .responseformmaster-close-btn {
    font-size: 1.25rem;
  }

  .responseformmaster-input {
    font-size: 0.9rem;
  }

  .responseformmaster-submit-btn {
    font-size: 0.95rem;
  }
}

.showallpricingmemberCard {
  position: fixed;
  top: 27%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 2rem;
  width: 80%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.close-btn {
  float: right;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #555;
}

.member-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.member-card {
  background: #f7f9fc;
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #ddd;
  transition: 0.3s ease;
}

.member-card:hover {
  background: #e9f1ff;
  border-color: #c4ddff;
}

.search_button_container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  background-color: #f9f9f9;
}

/* Style for buttons */
.search_button_container button {
  background-color: #4a90e2;
  color: #fff;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 160px;
}

.search_button_container button:hover {
  background-color: #357abd;
}

@media (max-width: 768px) {
  .search_button_container {
    flex-direction: column;
    align-items: center;
  }

  .search_button_container button {
    width: 80%;
    max-width: 300px;
  }
}
.purchaseexecutive-add-btn-disable {
  background-color: gray;
  cursor: not-allowed;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: background-color 0.3s;
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Perches/perchesexecutive.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgLG;;AAEH,QAAQ;;AAER;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oBAAoB;;AAEpB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2KG;;AAEH;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,kEAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA,0BAA0B;;AAE1B,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;EACV;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;EACV;EACA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB","sourcesContent":["/* .purchaseexecutive-wrapper {\n  padding: 2rem;\n  background: #eef1f5;\n  min-height: 100vh;\n}\n\n.purchaseexecutive-page-title {\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: #1e293b;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.purchaseexecutive-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1.5rem;\n}\n\n.purchaseexecutive-card {\n  background-color: #ffffff;\n  border-radius: 20px;\n  padding: 1.5rem;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.purchaseexecutive-card:hover {\n  transform: translateY(-5px);\n}\n\n.purchaseexecutive-card-header {\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.purchaseexecutive-card-title {\n  font-size: 1.3rem;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.purchaseexecutive-card-subtitle {\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.purchaseexecutive-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.purchaseexecutive-route-section {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 500;\n  color: #334155;\n  font-size: 0.95rem;\n}\n\n.purchaseexecutive-route-icon {\n  font-size: 1.3rem;\n  color: #2563eb;\n}\n\n.purchaseexecutive-details-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.purchaseexecutive-detail-item {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n  border-bottom: 1px dashed #e2e8f0;\n  padding-bottom: 0.4rem;\n}\n\n.purchaseexecutive-label {\n  color: #475569;\n  font-weight: 500;\n}\n\n.purchaseexecutive-value {\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.purchaseexecutive-loading-container {\n  margin-top: 3rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #334155;\n  font-size: 1rem;\n}\n\n.purchaseexecutive-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #cbd5e1;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .purchaseexecutive-page-title {\n    font-size: 1.6rem;\n  }\n\n  .purchaseexecutive-details-grid {\n    gap: 0.6rem;\n  }\n\n  .purchaseexecutive-detail-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.2rem;\n  }\n}\n\n.purchaseexecutive-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.purchaseexecutive-header-left {\n  display: flex;\n  flex-direction: column;\n}\n\n.purchaseexecutive-card-title {\n  font-size: 1.2rem;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.purchaseexecutive-card-subtitle {\n  font-size: 0.85rem;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.purchaseexecutive-add-btn {\n  padding: 0.4rem 1rem;\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.purchaseexecutive-add-btn:hover {\n  background-color: #1d4ed8;\n} */\n\n/* *** */\n\n.purchaseexecutive-wrapper {\n  padding: 20px;\n  min-height: 100vh;\n  background-color: #f5f6fa;\n}\n\n.purchaseexecutive-page-title {\n  font-size: 2rem;\n  color: #333;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.purchaseexecutive-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.purchaseexecutive-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  padding: 20px;\n  transition: transform 0.2s ease-in-out;\n}\n\n.purchaseexecutive-card:hover {\n  transform: translateY(-5px);\n}\n\n.purchaseexecutive-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n\n.purchaseexecutive-header-left {\n  display: flex;\n  flex-direction: column;\n}\n\n.purchaseexecutive-card-title {\n  font-size: 1.5rem;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.purchaseexecutive-card-subtitle {\n  font-size: 0.9rem;\n  color: #7f8c8d;\n}\n\n.purchaseexecutive-add-btn {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.3s;\n  margin-left: 5px;\n}\n\n.purchaseexecutive-add-btn:hover {\n  background-color: #2980b9;\n}\n\n.purchaseexecutive-route-section {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.purchaseexecutive-route-details {\n  font-size: 1.1rem;\n}\n\n.purchaseexecutive-route-from,\n.purchaseexecutive-route-to {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.purchaseexecutive-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.purchaseexecutive-detail-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.purchaseexecutive-label {\n  font-size: 0.9rem;\n  color: #7f8c8d;\n  font-weight: 500;\n}\n\n.purchaseexecutive-value {\n  font-size: 1rem;\n  color: #2c3e50;\n  word-break: break-word;\n}\n\n.purchaseexecutive-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  color: #7f8c8d;\n}\n\n.purchaseexecutive-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 1024px) {\n  .purchaseexecutive-page-title {\n    font-size: 1.8rem;\n  }\n\n  .purchaseexecutive-card {\n    padding: 15px;\n  }\n\n  .purchaseexecutive-card-title {\n    font-size: 1.3rem;\n  }\n\n  .purchaseexecutive-details-grid {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .purchaseexecutive-wrapper {\n    padding: 15px;\n  }\n\n  .purchaseexecutive-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .purchaseexecutive-add-btn {\n    width: 100%;\n  }\n\n  .purchaseexecutive-route-details {\n    font-size: 1rem;\n  }\n\n  .purchaseexecutive-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .purchaseexecutive-page-title {\n    font-size: 1.5rem;\n  }\n\n  .purchaseexecutive-card {\n    padding: 10px;\n  }\n\n  .purchaseexecutive-card-title {\n    font-size: 1.1rem;\n  }\n\n  .purchaseexecutive-card-subtitle {\n    font-size: 0.8rem;\n  }\n\n  .purchaseexecutive-add-btn {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n  }\n\n  .purchaseexecutive-value {\n    font-size: 0.9rem;\n  }\n}\n\n/* show all master */\n\n/* .masterpage-view-btn {\n  padding: 10px 20px;\n  background-color: #fab005;\n  color: white;\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.masterpage-view-btn:hover {\n  background-color: #f08c00;\n  transform: translateY(-2px);\n}\n\n.masterpage-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.masterpage-popup {\n  background-color: #fff;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 800px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n\n.masterpage-popup-header {\n  padding: 15px 20px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  z-index: 1;\n}\n\n.masterpage-popup-header h3 {\n  margin: 0;\n  color: #212529;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.masterpage-close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  transition: color 0.3s ease;\n}\n\n.masterpage-close-btn:hover {\n  color: #343a40;\n}\n\n.masterpage-popup-content {\n  padding: 20px;\n}\n\n.masterpage-popup-card {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 15px;\n  border-left: 4px solid #fab005;\n}\n\n.masterpage-popup-card p {\n  margin: 6px 0;\n  color: #495057;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.masterpage-popup-card p strong {\n  color: #343a40;\n  font-weight: 500;\n  min-width: 120px;\n}\n\n.masterpage-popup-card p span {\n  color: #6c757d;\n  flex: 1;\n  word-break: break-word;\n}\n\n@media (max-width: 768px) {\n  .masterpage-wrapper {\n    padding: 15px;\n  }\n\n  .masterpage-header {\n    padding: 12px 15px;\n  }\n\n  .masterpage-controls {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .masterpage-grid {\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  }\n\n  .masterpage-popup {\n    width: 95%;\n    max-height: 85vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .masterpage-header {\n    padding: 10px;\n  }\n\n  .masterpage-search-input {\n    max-width: 100%;\n  }\n\n  .masterpage-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .masterpage-card {\n    padding: 12px 15px;\n  }\n\n  .masterpage-card p {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .masterpage-card p strong {\n    min-width: auto;\n  }\n\n  .masterpage-popup-card p {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .masterpage-popup-card p strong {\n    min-width: auto;\n  }\n} */\n\n.masterpage-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 15, 15, 0.5);\n  backdrop-filter: blur(3px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.masterpage-popup {\n  background-color: #ffffff;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  position: relative;\n  padding: 24px 24px 16px;\n  animation: popupSlideIn 0.3s ease-out;\n}\n\n.masterpage-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.masterpage-popup-header h3 {\n  font-size: 20px;\n  margin: 0;\n  color: #222;\n}\n\n.masterpage-close-btn {\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: #888;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.masterpage-close-btn:hover {\n  color: #000;\n}\n\n.masterpage-popup-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.masterpage-popup-card {\n  background: #f9f9f9;\n  padding: 16px;\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.masterpage-popup-card p {\n  margin: 6px 0;\n  font-size: 14px;\n  color: #333;\n}\n\n.masterpage-popup-card strong {\n  font-weight: 600;\n  color: #111;\n}\n\n@keyframes popupSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .masterpage-popup {\n    max-width: 95%;\n    padding: 20px 16px;\n  }\n\n  .masterpage-popup-card p {\n    font-size: 13px;\n  }\n\n  .masterpage-popup-header h3 {\n    font-size: 18px;\n  }\n\n  .masterpage-close-btn {\n    font-size: 22px;\n  }\n}\n\n.masterpage-popup-card_button {\n  background-color: #2563eb; /* blue-600 */\n  color: white;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 1rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out, transform 0.1s ease;\n  margin-left: 65%;\n}\n\n.masterpage-popup-card_button:hover {\n  background-color: #1d4ed8; /* blue-700 */\n  transform: translateY(-2px);\n}\n\n.masterpage-popup-card_button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* matsrer response form */\n\n/* Overlay */\n.responseformmaster-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n  z-index: 9999;\n}\n\n.responseformmaster-popup {\n  background: #fff;\n  width: 100%;\n  max-width: 600px;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  height: 600px;\n  overflow: auto;\n}\n\n.responseformmaster-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background-color: #2563eb;\n  color: white;\n}\n\n.responseformmaster-close-btn {\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  color: white;\n  cursor: pointer;\n}\n\n.responseformmaster-content {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.responseformmaster-content h4 {\n  margin-top: 1rem;\n  color: #333;\n}\n\n.responseformmaster-input {\n  padding: 0.75rem;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.responseformmaster-submit-btn {\n  background-color: #2563eb;\n  color: white;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 10px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.responseformmaster-submit-btn:hover {\n  background-color: #1e40af;\n}\n\n@media (max-width: 768px) {\n  .view_add_vutton {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 8px;\n  }\n  .responseformmaster-popup {\n    max-width: 100%;\n  }\n\n  .responseformmaster-content {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .view_add_vutton {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 8px;\n  }\n  .responseformmaster-header h3 {\n    font-size: 1rem;\n  }\n\n  .responseformmaster-close-btn {\n    font-size: 1.25rem;\n  }\n\n  .responseformmaster-input {\n    font-size: 0.9rem;\n  }\n\n  .responseformmaster-submit-btn {\n    font-size: 0.95rem;\n  }\n}\n\n.showallpricingmemberCard {\n  position: fixed;\n  top: 27%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #fff;\n  padding: 2rem;\n  width: 80%;\n  max-width: 800px;\n  max-height: 80vh;\n  overflow-y: auto;\n  border-radius: 12px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n}\n\n.close-btn {\n  float: right;\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #555;\n}\n\n.member-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.member-card {\n  background: #f7f9fc;\n  padding: 1rem;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  transition: 0.3s ease;\n}\n\n.member-card:hover {\n  background: #e9f1ff;\n  border-color: #c4ddff;\n}\n\n.search_button_container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  background-color: #f9f9f9;\n}\n\n/* Style for buttons */\n.search_button_container button {\n  background-color: #4a90e2;\n  color: #fff;\n  border: none;\n  padding: 12px 20px;\n  font-size: 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  min-width: 160px;\n}\n\n.search_button_container button:hover {\n  background-color: #357abd;\n}\n\n@media (max-width: 768px) {\n  .search_button_container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .search_button_container button {\n    width: 80%;\n    max-width: 300px;\n  }\n}\n.purchaseexecutive-add-btn-disable {\n  background-color: gray;\n  cursor: not-allowed;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  transition: background-color 0.3s;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
